import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedStratalotRcpApiService } from './stratalot-rcp-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class StratalotRcpApiService extends GeneratedStratalotRcpApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
